import { render, staticRenderFns } from "./salesReturns.vue?vue&type=template&id=40aa6a48&scoped=true&"
import script from "./salesReturns.vue?vue&type=script&lang=js&"
export * from "./salesReturns.vue?vue&type=script&lang=js&"
import style0 from "./salesReturns.vue?vue&type=style&index=0&id=40aa6a48&lang=less&scoped=true&"
import style1 from "./salesReturns.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aa6a48",
  null
  
)

component.options.__file = "salesReturns.vue"
export default component.exports